import apiClient from "./axiosConfig";

const SALES_SUMMARY_PATH = "/dashboard/monthly-sales-summary/";

export const getMonthlySalesSummary = async () => {
  try {
    const url = process.env.REACT_APP_API_URL
      ? SALES_SUMMARY_PATH
      : `https://api.buyphone24.com/api${SALES_SUMMARY_PATH}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching monthly sales summary:", error);
    throw error;
  }
};
